import { createAsyncThunk } from "@reduxjs/toolkit";
import { TaskReportResponseMapper } from "./TaskReportResponseMapper";
import axiosInstance from "../axiosInstance/axiosInstance";
import { HttpStatusCode } from "axios";
import { MilestoneTaskReportResponse } from "./MilestoneTaskReportResponse";
import * as XLSX from "xlsx";
import { MilestoneTask } from "./MilestoneTask";
import { MilestoneTaskReport } from "./MilestoneTaskReport";

export const fetchTaskReportsAsync = createAsyncThunk(
  "taskReports/fetchTaskReportsAsync",
  async (milestoneId: number, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get<MilestoneTaskReportResponse[]>(
        `/taskReports/${milestoneId}`
      );

      if (response.status !== HttpStatusCode.Ok) {
        throw new Error("Failed to fetch task reports");
      }

      const data = response.data;
      const taskReportResponseMapper = new TaskReportResponseMapper();
      const mappedData: MilestoneTaskReport[] = data.map(
        taskReportResponseMapper.mapMilestoneTaskReportResponseToMilestoneTaskReport
      );

      return mappedData;
    } catch (error) {
      console.error("Error fetching task reports:", error);
      throw error;
    }
  }
);

export const fetchAllTaskReportsAsync = createAsyncThunk(
  "taskReports/fetchAllTaskReportsAsync",
  async (milestoneId: number, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get<MilestoneTaskReportResponse[]>(
        `/taskReports/${milestoneId}`
      );

      if (response.status !== HttpStatusCode.Ok) {
        throw new Error("Failed to fetch all task reports");
      }

      const data = response.data;
      const taskReportResponseMapper = new TaskReportResponseMapper();
      const mappedData = data.map(
        taskReportResponseMapper.mapMilestoneTaskReportResponseToMilestoneTaskReport
      );

      return mappedData;
    } catch (error) {
      console.error("Error fetching all task reports:", error);
      return rejectWithValue(error);
    }
  }
);

export const createExcelFromTaskReports = (taskReports: MilestoneTask[]) => {
  const worksheet = XLSX.utils.json_to_sheet(taskReports);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "TaskReports");
  XLSX.writeFile(workbook, "TaskReports.xlsx");
};
